export default {
  // Hero
  hotelHeroKicker: 'Über uns',
  hotelHeroTitle1: 'Ein Haus.',
  hotelHeroTitle2: 'Liebe Menschen.',
  hotelHeroTitle3: 'Viel Herzlichkeit.',
  hotelHeroLead: 'Der Alpenhof steht für bayerische Gastfreundschaft, persönliche Betreuung und einen Ort, an dem sich Gäste wirklich willkommen fühlen.',
  hotelHeroCareerInline: 'Wir stellen ein',
  hotelHeroCareerCardKicker: '✦ Wir stellen ein',
  hotelHeroCareerCardText: 'Herzliche Menschen gesucht →',

  // Tradition
  hotelTradTitle: 'Tradition trifft Gegenwart',
  hotelTradText1: 'Was 1911 als Villa eines Schriftstellers begann, ist heute ein Ort, an dem Geschichte spürbar wird – ohne dabei stehen zu bleiben. Der Alpenhof verbindet bayerische Tradition mit zeitgemäßem Komfort und einer Gastfreundschaft, die von Herzen kommt.',
  hotelTradText2: 'Geführt von einer Familie, geprägt von den Menschen, die hier arbeiten – und lebendig durch Gäste, die immer wieder zurückkehren.',

  // Werte
  hotelValuesKicker: 'Unsere Werte',
  hotelValuesTitle: 'Was uns ausmacht',
  hotelValuesLead: 'Drei Dinge prägen den Alpenhof seit jeher – und machen ihn zu dem, was er heute ist.',
  hotelVal1Title: 'Herzlichkeit',
  hotelVal1Text: 'Wir empfangen unsere Gäste nicht nur – wir nehmen sie auf. Mit Aufmerksamkeit, Wärme und dem Gefühl, wirklich willkommen zu sein.',
  hotelVal2Title: 'Hohe Qualität',
  hotelVal2Text: 'Schlafen wie im Himmel, Frühstücken wie ein König.',
  hotelVal3Title: 'Perfekte Lage',
  hotelVal3Text: 'Zwischen See, Stadt und Alpen – der Alpenhof liegt genau dort, wo Bayern am schönsten ist.',

  // Frühstück
  hotelBfKicker: 'Frühstück & Aufenthalt',
  hotelBfTitle: 'Leben wie der Kini persönlich.',
  hotelBfLead: 'Der Morgen beginnt im Alpenhof genussvoll und ohne Eile. Unser Frühstücksraum strahlt Gemütlichkeit aus – im Sommer lockt der Garten.',
  hotelBfFeat1Title: 'Hochwertige Produkte',
  hotelBfFeat1Text: 'Bio-Erzeugnisse der Andechser Molkerei. Semmeln und Brot von der lokalen Bio-Bäckerei (als bester Bäcker Europas ausgezeichnet). Und weitere hochwertige Produkte.',
  hotelBfFeat2Title: 'Persönlicher Service',
  hotelBfFeat2Text: 'Sie möchten Ihr Frühstücksei wie Sie es lieben? Oder eine besondere Kaffee- oder Tee-Spezialität? Wir gehen auf Ihre Wünsche ein.',
  hotelBfFeat3Title: 'Den Tag ausklingen lassen',
  hotelBfFeat3Text: 'Bei einem Glas Wein oder Bier in unserer Kachelofenstube, im lauschigen Garten. Oder stöbern Sie in unserer Bibliothek.',

  // Impressionen
  hotelGalleryKicker: 'Impressionen',
  hotelGalleryTitle: 'Ein Blick ins Haus',
  hotelGalleryLead: 'Tradition, Gemütlichkeit und bayerischer Charme – in jedem Winkel spürbar.',

  // CTA
  hotelCtaTitle: 'Bereit für Ihren Aufenthalt?',
  hotelCtaText: 'Erleben Sie bayerische Gastfreundschaft in einem Haus mit Geschichte, Herz und perfekter Lage.',
  hotelCtaButton: 'Jetzt Verfügbarkeit prüfen',

  // Karriere
  hotelCareerKicker: 'Karriere',
  hotelCareerTitle: 'Arbeiten im Alpenhof',
  hotelCareerLead: 'Wir sind immer auf der Suche nach herzlichen Menschen, die unsere Leidenschaft für Gastfreundschaft teilen. Schreiben Sie uns – auch initiativ.',
  hotelJob1Title: 'Rezeptionist/-in',
  hotelJob1Details: 'Teilzeit oder Vollzeit · Gauting',
  hotelJob2Title: 'Servicemitarbeiter/-in',
  hotelJob2Details: 'Frühstücksservice · Teilzeit · Gauting',
  hotelJob3Title: 'Mitarbeiter/-in Housekeeping',
  hotelJob3Details: 'Teilzeit · Gauting',
  hotelCareerApply: 'Bewerben',
  hotelCareerNoFitText: 'Keine passende Stelle dabei?',
  hotelCareerNoFitLink: 'Initiativbewerbung willkommen.',
};
